import {put, takeLatest, call} from 'redux-saga/effects';
import * as productService from "../../../../services/productService";
import {
    ADD_PRODUCT,
    ADD_PRODUCT_SUCCESS,
    ADD_PRODUCT_ERROR
}
    from "../../../actions/menu";

function* addProductSaga(action) {
    try {
        const data=yield call(productService.AddProduct,action.payload)
        
        yield put({
            type: ADD_PRODUCT_SUCCESS,
            payload: {product : data ,  productType : action.payload.payload.productType}
        });

    } catch (error) {
        yield put({
            type: ADD_PRODUCT_ERROR,error: error.data
        });
    }
}


export function* addProductSagaWatcher() {
    yield takeLatest(ADD_PRODUCT, addProductSaga);
}